<template>
  <span id="close-billing-section" v-if="shouldBeDisplayed()">
    <el-button v-if="!isDropDownItem" id="btn-close-billing" type="success" plain @click="dialogVisible = true" size="mini">
      {{ $t('customerService.shipment.closeBilling') }}
    </el-button>
    <el-dropdown-item v-if="isDropDownItem" id="close-billing-dropdown-item" @click.native="dialogVisible = true">
      <span class="more-actions-option">{{ $t('customerService.shipment.closeBilling') }}</span>
    </el-dropdown-item>
    <el-dialog
      :close-on-click-modal="false"
      v-on:open="handleOpen"
      :title="$t('customerService.shipment.closeBilling')"
      :visible.sync="dialogVisible"
      width="35%"
      class="dialog-with-cols"
      id="close-billing-dialog"
      append-to-body
    >
      <el-form :model="form" :rules="formRules" ref="form" label-position="top" size="mini">
        <el-row>
          <el-col :span="24" class="form-vertical-item">
            <label class="span-small-list">{{ $t('customerService.shipment.closeBillingText') }}</label>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="form-vertical-item">
            <el-form-item :label="$t('customerService.shipment.closeBillingFrom')" prop="dateFrom"
                          class="inline-input">
              <el-date-picker
                class="el-dropdown-new drop-sp date-dob"
                v-model="form.dateFrom"
                format="MM/dd/yyyy"
                :clearable="false"
                type="date"
                @change="handleDateFromChange"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :md="24" :sm="24" :xs="24" class="form-vertical-item">
            <el-form-item :label="$t('customerService.shipment.closeBillingTo')" prop="dateTo"
                          class="inline-input">
              <el-date-picker
                class="el-dropdown-new drop-sp date-dob"
                v-model="form.dateTo"
                format="MM/dd/yyyy"
                :clearable="false"
                type="date"
                @change="handleDateToChange"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div id="add-dialog-footer" slot="footer" class="dialog-footer form-vertical-item flex-reverse-direction">
        <el-button type="primary" id="form-run-rating-button" @click="submitForm()" size="mini">{{ $t('customerService.shipment.closeBilling') }}</el-button>
        <el-button id="form-clear-button" @click="resetForm()" size="mini">{{ $t('common.clear') }}</el-button>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import { Message } from 'element-ui';
import constants from '@/utils/constants';

export default {
  name: 'CloseBilling',
  props: {
    isDropDownItem: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['shipment']),
  },
  mounted() {
    if (this.shouldBeDisplayed() && this.isDropDownItem) {
      this.$emit('displayDropdown');
    }
    this.$store.dispatch('shipment/getCloseBillingMaxDayRange')
      .then((response) => {
        this.maxDayRange = response.data;
      });
  },
  data() {
    const validateDateRange = (rule, value, callback) => {
      this.$refs.form.clearValidate();
      if (this.maxDayRange && this.form.dateFrom && this.form.dateTo) {
        if (moment(this.form.dateTo).dayOfYear() - moment(this.form.dateFrom).dayOfYear() + 1 > this.maxDayRange) {
          callback(new Error(this.$t('customerService.shipment.error.dayRangeInvalid').replace('[days]', this.maxDayRange)));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      maxDayRange: null,
      dialogVisible: false,
      form: {
        dateFrom: null,
        dateTo: null
      },
      formRules: {
        dateFrom: [
          { required: true, message: this.$t('customerService.shipment.error.dateFromRequired'), trigger: 'blur' },
          { validator: validateDateRange, trigger: 'change' }
        ],
        dateTo: [
          { required: true, message: this.$t('customerService.shipment.error.dateToRequired'), trigger: 'blur' },
          { validator: validateDateRange, trigger: 'change' }
        ]
      }
    };
  },
  methods: {
    shouldBeDisplayed() {
      return this.$can(this.permissions.BILLING.CLOSE_BILLING);
    },
    handleOpen() {
      this.$nextTick(() => {
        this.resetForm();
      });
    },
    getDefaultDateFrom() {
      return this.shipment.actualFilters.outboundDateFrom || moment().add(-1, 'days').toDate();
    },
    getDefaultDateTo() {
      return this.shipment.actualFilters.outboundDateTo || this.shipment.actualFilters.outboundDateFrom
        || moment().add(-1, 'days').toDate();
    },
    handleDateFromChange() {
      if (moment(this.form.dateFrom).isAfter(moment(this.form.dateTo))) {
        this.form.dateTo = this.form.dateFrom;
      }
    },
    handleDateToChange() {
      if (moment(this.form.dateTo).isBefore(moment(this.form.dateFrom))) {
        this.form.dateFrom = this.form.dateTo;
      }
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          Message.closeAll();
          const loading = this.$loading(constants.LOADING.CLOSE_BILLING_CONFIG);
          this.$store
            .dispatch('shipment/closeBilling', this.form)
            .then((response) => {
              this.$store.dispatch('shipment/search', {});
              loading.close();
              if (response.data === true) { // closed billing with all invoices properly
                this.$message.success(response.message);
              } else { // closed billing with errors on invoice generation
                this.$message.warning(response.message);
              }
              this.dialogVisible = false;
            })
            .catch(() => {
              loading.close();
            });
        }
      });
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.form.dateTo = this.getDefaultDateTo();
      this.form.dateFrom = this.getDefaultDateFrom();
    }
  }
};
</script>
